import { render, staticRenderFns } from "./mediaDetail.vue?vue&type=template&id=3c305fc4"
import script from "./mediaDetail.vue?vue&type=script&lang=js"
export * from "./mediaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports